<template>
    <HeaderComponent></HeaderComponent>
    <MenuBarComponent></MenuBarComponent>
    <div id="background-area">
        <div class="content-area">
            <div id="profile-area">
                <div id="profile-text">
                    <div>こんにちは、<b>minao</b>です。</div>
                    <br>
                    <div>こちらは日々の活動を記録するための趣味のホームページです。</div>
                    <div>気が向いたら更新し、ゆるく運営したいと思います。</div>
                    <br>
                    <b>趣味</b>
                    <div>    旅：温泉、水族館、岬、グルメ巡りが好き。</div>
                    <div>    お絵かき：デジタルでアニメやゲームのキャラ描くことが多い。</div>
                    <div>    ボウリング：ハウスボール勢。アベレージ170ぐらい。ベストスコア262。</div>
                    <div>    メイドカフェ巡り：国内外問わずまったりと。</div>
                    <div>    ダンレボ：ノンバー勢。最高クリアはSP足18、DP足17。</div>
                    <div>    QMA：協力プレイメイン。社会と理系が好き。</div>
                    <div>    プログラミング：JavaScript、Python、C++など。</div>
                    <br>
                    <b>SNSリンク</b>
                    <div>    あまり更新していないですが以下のアカウントがあります。</div>
                    <div>    X：<a href="https://x.com/broken_minao" class="link">@broken_minao</a></div>
                    <div>    pixiv：<a href="https://www.pixiv.net/users/112488625" class="link">minao</a></div>
                    <div>    Instagram：<a href="https://www.instagram.com/broken_minao/" class="link">broken_minao</a></div>
                </div>
            </div>
        </div>
        <div id="latest-blog-article-header-area">
            <div id="latest-blog-article-header-text">
                ブログ新着記事
            </div>
        </div>
        <div class="content-area">
            <router-link
                v-for="article in articles"
                class="latest-blog-article-info-area link"
                v-bind:to="getLinkParamsToArticle(article.id)"
            >
                <div class="latest-blog-article-created-date-area">
                    <div class="latest-blog-article-created-date-text">
                        {{getDateString(article.created_time)}}
                    </div>
                </div>
                <div class="latest-blog-article-category-area">
                    <div class="latest-blog-article-category-text">
                        {{getCategoryName(article.category_id)}}
                    </div>
                </div>
                <div class="latest-blog-article-title-area">
                    <div class="latest-blog-article-title-text">
                        {{article.title}}
                    </div>
                </div>
            </router-link>
        </div>
    </div>
    <FooterComponent></FooterComponent>
</template>

<script>
    import { ref, onMounted } from "vue";
    import axios from "axios";

    import HeaderComponent from "@/components/header.vue";
    import MenuBarComponent from "@/components/menuBar.vue";
    import FooterComponent from "@/components/footer.vue";

    import router from "@/router/index.js";
    import httpUtility from "@/js/common/httpUtility.js";
    import datetimeUtility from "@/js/common/datetimeUtility.js";

    import config from "@/configs/config.js";
    import blogPathConfig from "@/configs/blog/pathConfig.js";

    export default {
        name: "HomeView",
        components: {
            HeaderComponent,
            MenuBarComponent,
            FooterComponent
        },
        setup() {
            // -----------------------------------------
            // 定数
            // -----------------------------------------

            // -----------------------------------------
            // 変数
            // -----------------------------------------
            let articles = ref({});
            let categories = ref([]);

            // -----------------------------------------
            // 画面読み込み時処理
            // -----------------------------------------
            onMounted(() => {
                getArticles();
                getCategories();
            })

            //-----------------------------------------
            // メソッド（APIコールなし・テンプレート内使用なし）
            //-----------------------------------------
            function sortByCreatedTime(objects) {
                // created_time降順にソート
                objects.sort((a, b) => {
                    return new Date(b.created_time) - new Date(a.created_time);
                })
            }

            //-----------------------------------------
            // メソッド（APIコールなし・テンプレート内使用あり）
            //-----------------------------------------
            function getLinkParamsToArticle(article_id) {
                const path_params = {
                    article_id: article_id
                };
                return {name: "blog_article", params: path_params};
            }

            function getCategoryName(category_id) {
                const category = categories.value.find(category => category.id === category_id);
                return category ? category.name : null;
            }

            //-----------------------------------------
            // メソッド（APIコールあり・テンプレート内使用なし）
            //-----------------------------------------
            function getArticles() {
                const query_params = {
                    limit: config.DISPLAY_BLOG_LATEST_ARTICLE_NUM,
                }
                axios.get(`${httpUtility.getBackendAPIUrl(blogPathConfig.ARTICLE_API_PATH)}`, {params: query_params})
                .then(response => {
                    articles.value = response.data["articles"];
                    sortByCreatedTime(articles.value);
                })
                .catch((e) => {
                    router.push({name: "error"});
                });
            }

            function getCategories() {
                axios.get(`${httpUtility.getBackendAPIUrl(blogPathConfig.CATEGORY_API_PATH)}`)
                .then(response => {
                    categories.value = response.data["categories"];
                })
                .catch(() => {
                    router.push({name: "error"});
                });
            }

            // -----------------------------------------
            // テンプレートへの返り値
            // -----------------------------------------
            return {
                getDateString: datetimeUtility.getDateString,
                articles,
                getLinkParamsToArticle, 
                getCategoryName,
            };
        }
    };
</script>

<style scoped lang="scss">
    @import "@/scss/views/home.scss";
</style>